import {Component} from '@angular/core';

import {LayoutService} from '../layout.service';

declare var $:any;

@Component({
  selector: 'sa-minify-menu',
  template: `<span class="minifyme" id="minifyButton" (click)="toggle()">
    <i class="ticket-icon-dropdown_g hit" id="minifyIcon" style="font-size: 35px;
    position: relative;right: 4px;top: -4px;margin-right: 0px;"></i>
    </span>`,
})

export class MinifyMenuComponent {

  constructor(private layoutService: LayoutService) {
  }

  toggle() {
    this.layoutService.onMinifyMenu();
  }
}
